<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ShareCode',
})
</script>
<template>
  <div class="page">
    <NavBar :title="lang('Referral')" fixed transparent>
      <template #right>
        <div class="header_right" @click="onRule">
          <img
            class="right_filter"
            src="@/assets/images/share/share_rule.png"
          />
        </div>
      </template>
    </NavBar>
    <div class="container">
      <div class="bg">
        <div class="bgImg">
          <img src="@/assets/images/share/share_bg.jpg" />
        </div>
        <div class="bgColor"></div>
        <div class="bgColorBottom"></div>
      </div>
      <div class="content">
        <div class="total">{{ data.totalEarn || 0 }}</div>
        <div class="total_text">{{ lang('Total_Earnings') }}</div>
        <div class="card">
          <div class="top_refer">
            <img class="star" src="@/assets/images/share/star.png" />
            <div class="text">
              {{
                isTopReferrer ? lang('Top_Referrer') : lang('Starter_Referrer')
              }}
            </div>
            <img class="star" src="@/assets/images/share/star.png" />
          </div>
          <div class="top_desc">
            {{ lang('refer_desc') }}
          </div>
          <div class="points">
            <div class="poi">
              <div class="poi_value">500</div>
              <div class="poi_text">{{ lang('points') }}</div>
            </div>
          </div>
          <div v-if="!isTopReferrer" class="rm">
            <div class="rm_item_n">
              <div class="ri_top">
                <div class="rt_value">6</div>
                <div class="rt_text">RM</div>
              </div>
              <div class="ri_center">
                <img src="@/assets/images/share/line.png" />
              </div>
              <div class="ri_bottom">
                <div class="rb_text">{{ lang('cash_voucher') }}</div>
              </div>
            </div>

            <div class="rm_item_n">
              <div class="ri_top">
                <div class="rt_value">5</div>
                <div class="rt_text">RM</div>
              </div>
              <div class="ri_center">
                <img src="@/assets/images/share/line.png" />
              </div>
              <div class="ri_bottom">
                <div class="rb_text">{{ lang('cash_voucher') }}</div>
              </div>
              <div class="label">
                <div class="label_text">{{ lang('international') }}</div>
              </div>
            </div>
          </div>
          <div v-else class="rm">
            <div class="rm_item_n">
              <div class="ri_top">
                <div class="rt_value">6</div>
                <div class="rt_text">RM</div>
              </div>
              <div class="ri_center">
                <img src="@/assets/images/share/line.png" />
              </div>
              <div class="ri_bottom">
                <div class="rb_text">{{ lang('cash_voucher') }}</div>
              </div>
            </div>
            <div class="rm_item_n">
              <div class="ri_top">
                <div class="rt_value">2</div>
                <div class="rt_text">RM</div>
              </div>
              <div class="ri_center">
                <img src="@/assets/images/share/line.png" />
              </div>
              <div class="ri_bottom">
                <div class="rb_text">{{ lang('cash_voucher') }} x2</div>
              </div>
            </div>
            <div class="rm_item_n">
              <div class="ri_top">
                <div class="rt_value">5</div>
                <div class="rt_text">RM</div>
              </div>
              <div class="ri_center">
                <img src="@/assets/images/share/line.png" />
              </div>
              <div class="ri_bottom">
                <div class="rb_text">{{ lang('cash_voucher') }}</div>
              </div>
              <div class="label">
                <div class="label_text">{{ lang('international') }}</div>
              </div>
            </div>
            <div class="rm_item_n">
              <div class="ri_top">
                <div class="rt_value">3</div>
                <div class="rt_text">RM</div>
              </div>
              <div class="ri_center">
                <img src="@/assets/images/share/line.png" />
              </div>
              <div class="ri_bottom">
                <div class="rb_text">{{ lang('cash_voucher') }} x2</div>
              </div>
              <div class="label">
                <div class="label_text">{{ lang('next_day_delivery') }}</div>
              </div>
            </div>
          </div>

          <div v-if="isTopReferrer" class="jt_logo_light">
            <img src="@/assets/images/share/jt_express_logo_light.png" />
          </div>

          <template v-if="!isTopReferrer">
            <div
              v-if="langType === 'zh'"
              class="jt_desc1"
              style="margin-top: 24px"
            >
              邀请
              <span style="color: #e52129"
                >{{ TOP_USER - data?.memberCount || 0 }}位新用户</span
              >
              升级为
            </div>
            <div
              v-if="langType === 'en'"
              class="jt_desc1"
              style="margin-top: 24px"
            >
              Invite
              <span style="color: #e52129"
                >{{ TOP_USER - data?.memberCount || 0 }} new users</span
              >
              to upgrade to
            </div>
            <div
              v-if="langType === 'ms'"
              class="jt_desc1"
              style="margin-top: 24px"
            >
              Jemput
              <span style="color: #e52129"
                >{{ TOP_USER - data?.memberCount || 0 }} pengguna baru</span
              >
              untuk dinaik taraf ke to
            </div>
            <div class="jt_desc1">「 {{ lang('Top_Referrer') }} 」</div>
          </template>
          <template v-else>
            <div class="jt_desc1">{{ lang('already_top_referral') }}</div>
            <div class="jt_desc2">
              {{ lang('already_top_referral_text') }}
            </div>
          </template>

          <div class="precess_box">
            <div
              class="precess"
              :style="{ width: ((data.memberCount || 0) / 8) * 100 + '%' }"
            ></div>
            <div
              class="currentTop"
              :style="{ left: (TOP_USER / 8) * 100 + '%' }"
            >
              <div class="ct_img">
                <img
                  class="ct_img_1"
                  src="@/assets/images/share/top_refer.png"
                />
                <div class="ct_bt">
                  <div class="ct_ref">{{ lang('Top_Referrer') }}</div>
                  <div v-if="!isTopReferrer" class="ct_lock">
                    <img
                      class="ct_lock_icon"
                      src="@/assets/images/share/lock.png"
                    />
                    <div class="ct_lock_text">
                      {{ lang('open_lock_five_new_user') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="share_code">{{ data.code || '' }}</div>
          <div class="share_code_desc">{{ lang('your_referral_code') }}</div>
          <div class="share_btn" @click="onShare">{{ lang('share') }}</div>
        </div>

        <!-- 邀请记录 -->
        <div class="invi_card">
          <div class="invi_head">
            <div class="invi_line"></div>
            <div class="invi_title">{{ lang('Invitation_record') }}</div>
          </div>
          <div class="invi_list">
            <div
              v-for="item in [1, 2, 3, 4, 5, 6, 7, 8]"
              :key="item"
              class="il_item"
            >
              <div class="user_head">
                <img
                  v-if="data.memberCount >= item"
                  src="@/assets/images/share/default_head.png"
                />
              </div>
              <div class="user_name">{{ lang('n_user', [item]) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup name="ShareCode">
import NavBar from '@/components/NavBar.vue'
import { useRouter } from 'vue-router'
import { ref, onMounted, onUnmounted, computed } from 'vue'
import lang from '@/langs'
import { getShareCode } from '@/api/requests/share'
// import { loading } from '@/utils/loading'
import { onNativeShare, trackClick } from '@/utils/native'
import { useUserStore } from '@/stores/user'
const TOP_USER = 5

const isLoading = ref(true)
const { userInfo } = useUserStore()

const { langType, safeArea } = userInfo
const safeAreaTop = `${safeArea.top}px`
const router = useRouter()

const data: any = ref({})
const isTopReferrer = ref(false)
const onRule = () => {
  let lt: any = langType
  if (lt === 'ms') {
    lt = 'my'
  }
  router.push({
    path: `/shareRule${lt}`,
    query: {}
  })
}

const onShare = () => {
  if (!isLoading.value) {
    trackClick({
      page_name: '分享有礼-Share&Earn',
      page_id: '0000068',
      button_name: '分享-Share',
      element_id: '0010050'
    })
    onNativeShare(data.value?.desc || '')
  }
}

const fetchShareCode = async () => {
  // loading.show()
  try {
    const res: any = await getShareCode({ parameter: { lang: langType } })
    // res.memberCount = '5'
    console.log('res:', res)
    data.value = res || {}
    isTopReferrer.value = res?.memberCount >= TOP_USER ? true : false
    isLoading.value = false
  } catch (error) {
    isLoading.value = false
  }

  // loading.hide()
}

const scrollTop = ref(0)
const background = computed(() => {
  // return `rgba(233, 33, 36, ${scrollTop.value / 120})`
  return `rgba(194, 32, 45, ${scrollTop.value / 120})`
})

const handleScroll = () => {
  // 获取滚动距离
  scrollTop.value = document.body.scrollTop
}

onMounted(() => {
  document.body.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  document.body.removeEventListener('scroll', handleScroll)
})
const init = () => {
  fetchShareCode()
}
init()
</script>

<style lang="less" scoped>
.page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  :deep(.van-icon-arrow-left) {
    color: #fff !important;
  }
  :deep(.van-nav-bar__title) {
    color: #fff !important;
  }
  :deep(.van-nav-bar__content) {
    background: v-bind(background) !important;
  }
  .header_right {
    .flex_align_center;
  }
  .right_filter {
    width: 22px;
  }
}
header {
  width: 100%;
}
main {
  flex: 1;
  overflow-y: auto;
  margin-top: 10px;
}
.container {
  width: 100vw;
  height: 100vh;
  position: relative;
  .bg {
    width: 100%;
    height: 680px;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
  }
  .bgImg {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .bgColor {
    flex: 1;
    background-color: #e92124;
  }
  .bgColorBottom {
    width: 100%;
    height: 100px;
    background: linear-gradient(
      180deg,
      #e92124 13%,
      rgba(235, 34, 40, 0.07) 100%
    );
  }
}
.content {
  margin-top: calc(65px + v-bind(safeAreaTop));
  position: relative;
  z-index: 11;
  padding: 0 10px;
  padding-bottom: 28px;
  .total {
    font-size: 43px;
    font-weight: bold;
    text-align: center;
    color: #ffffff;
    line-height: 43px;
  }
  .total_text {
    margin-top: 5px;
    opacity: 0.8;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    line-height: 20px;
  }
  .card {
    width: 100%;
    border-radius: 5px;
    background: linear-gradient(180deg, #ffd8d9, #ffffff 54%);
    overflow: hidden;
    color: #e52129;
    padding: 10px 10px 36px 10px;
    margin-top: 16px;
    .top_refer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 6px;
      .star {
        width: 18px;
      }
      .text {
        margin: 0 10px;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        color: #e52129;
        line-height: 25px;
      }
    }
    .top_desc {
      opacity: 0.6;
      font-size: 13px;
      text-align: center;
      color: #e52129;
      line-height: 17px;
      margin-top: 6px;
    }
    .points {
      width: 100%;
      height: 64px;
      background: #ffffff;
      border-radius: 6px;
      box-shadow: 0px 1px 2.5px 0px rgba(142, 0, 0, 0.07);
      margin-top: 15px;
      background-image: url('@/assets/images/share/jt_express_logo.png');
      background-size: 200px 45px;
      background-repeat: no-repeat;
      background-position: center;
      display: flex;
      align-items: center;
      justify-content: center;
      .poi {
        display: flex;
        align-items: flex-end;
        margin-top: 2px;
      }
      .poi_value {
        font-size: 32px;
        font-weight: bold;
        color: #e52129;
        line-height: 28px;
      }
      .poi_text {
        font-size: 14px;
        font-weight: bold;
        color: #e52129;
        line-height: 14px;
        margin-bottom: 2px;
      }
    }
    .rm {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .rm_item_n {
        --width: calc(100% / 2 - 3px);
        width: var(--width);
        height: 95px;
        margin-top: 6px;
        position: relative;
        // 30 64 6
        .ri_top {
          width: 100%;
          height: 58px;
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
          background: #fff;
          display: flex;
          // align-items: center;
          justify-content: center;
          box-shadow: 0px 1px 2.5px 0px rgba(142, 0, 0, 0.07);
        }
        .ri_center {
          width: 100%;
          img {
            width: 100%;
          }
        }
        .ri_bottom {
          width: 100%;
          height: 24px;
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0px 1px 2.5px 0px rgba(142, 0, 0, 0.07);
        }
        .rt_value {
          font-size: 32px;
          font-weight: bold;
          line-height: 28px;
          margin-top: 20px;
        }
        .rt_text {
          font-size: 14px;
          font-weight: bold;
          line-height: 14px;
          margin-top: 33px;
          margin-left: 2px;
        }
        .rb_text {
          font-size: 12px;
          font-weight: bold;
          line-height: 12px;
          margin-bottom: 4px;
        }
        .label {
          height: 15px;
          line-height: 17px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #eb2127;
          border-top-right-radius: 6px;
          border-bottom-left-radius: 6px;
          position: absolute;
          right: 0;
          top: 0;
          color: #fff;
          font-size: 12px;
          padding: 0 3px;
          .label_text {
            transform: scale(0.84);
            margin-top: 1px;
          }
        }
        // border-radius: 6px;
      }
    }
    .jt_logo_light {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 150px;
        margin-top: -15px;
      }
    }
    .jt_desc1 {
      font-size: 17px;
      font-weight: bold;
      text-align: center;
      color: #333333;
      line-height: 22px;
    }
    .jt_desc2 {
      opacity: 0.6;
      font-size: 13px;
      text-align: center;
      color: #333333;
      line-height: 13px;
      margin-top: 5px;
    }
    .precess_box {
      margin-top: 18px;
      width: 100%;
      height: 12px;
      background: #ffeaea;
      border-radius: 8px;
      box-shadow: 0px 2px 3.5px 0px #f9bdba inset;
      position: relative;
      .precess {
        height: 12px;
        background: #eb2127;
        border-radius: 8px;
      }
      .currentTop {
        position: absolute;
        top: 50%;
        transform: translateX(-16px) translateY(-50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        .ct_img {
          width: 32px;
          position: relative;
        }
        .ct_img_1 {
          width: 32px;
          height: 32px;
        }
        .ct_ref {
          margin-top: 2px;
          font-size: 12px;
          font-weight: bold;
          text-align: center;
          color: #8c0a0f;
          line-height: 12px;
          width: 80px;
        }
        .ct_bt {
          position: absolute;
          top: 32px;
          left: 50%;
          transform: translateX(-50%);
          width: 170px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .ct_lock {
          display: flex;
          align-items: center;
          height: 16px;
          background: #fff1f1;
          border-radius: 10px;
          padding: 0 6px;
          margin-top: 2px;
        }
        .ct_lock_icon {
          width: 7px;
        }
        .ct_lock_text {
          font-size: 10px;
          text-align: center;
          color: #8c0a0f;
          line-height: 10px;
          margin-left: 2px;
        }
      }
    }
    .share_code {
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      color: #e52129;
      line-height: 39px;
      height: 39px;
      margin-top: 60px;
    }
    .share_code_desc {
      font-size: 14px;
      font-weight: bold;
      text-align: center;
      color: #333333;
      line-height: 20px;
    }
    .share_btn {
      width: 289px;
      height: 44px;
      background: linear-gradient(90deg, #be222d 1%, #e92329);
      border-radius: 22px;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      color: #ffffff;
      line-height: 44px;
    }
  }
  .invi_card {
    margin-top: 10px;
    padding: 10px;
    background: #fff;
    border-radius: 5px;
    .invi_head {
      display: flex;
      align-items: center;
      margin-top: 6px;
    }
    .invi_line {
      width: 3px;
      height: 14px;
      background: #e52129;
      border-radius: 2px;
    }
    .invi_title {
      font-size: 17px;
      font-weight: bold;
      text-align: center;
      color: #333333;
      line-height: 17px;
      margin-left: 6px;
    }
    .invi_list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .il_item {
      width: calc(100% / 4);
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .user_head {
      width: 50px;
      height: 50px;
      border-radius: 25px;
      background: #eaeaec;
      img {
        width: 50px;
        height: 50px;
      }
    }
    .user_name {
      width: 70px;
      margin-top: 3px;
      font-size: 12px;
      text-align: center;
      color: #333333;
      .text_multiple_etc(2);
    }
  }
}
</style>
